<template>
    <div class="row appointment" v-on:click="selectAppointment();">
        <div class="col-3 category d-flex align-items-center">
            <p v-bind:class="'cat'+appointment.category">{{appointment.category}}</p>
        </div>
        <div class="col content">
            <p class="timespan">
                {{appointment.time_start.format('HH:mm')}}-{{appointment.time_end.format('HH:mm')}}
            </p>
            <div class="row">
                <div class="col-6 pl-0">
                    <span>Kategori</span>
                    <p>{{translateCategory(appointment.category)}}</p>
                </div>
                <div class="col-6">
                    <span>Tid</span>
                    <p>
                        {{ duration }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import appointmentMixins from '@/mixins/appointment.js';

export default {
    props: [
        'appointment',
    ],
    mixins: [appointmentMixins],

    created: function() {
        this.parseAppointment();
    },

    computed: {
        duration: function() {
            var duration = parseInt(this.appointment.duration);
            var durationString = '';
            
            if(duration > 60) {
                let hours = Math.trunc(duration/60);
                durationString = hours+'t ';
                duration -= 60*hours;
            }

            duration > 0 ? durationString += duration+'m':null;

            return durationString;
        }
    },

    methods: {
        selectAppointment() {
            this.$emit('selectAppointment', this.appointment);
        },
        parseAppointment() {
            let parsedAppointment = this.appointment;

            parsedAppointment.date = this.$moment(this.appointment.date);
            parsedAppointment.time_start = this.$moment(this.appointment.time_start);
            parsedAppointment.time_end = this.$moment(this.appointment.time_end);
        }
    }
}
</script>

